$(function ()
{
    // Hide first breadcrumb if there is a second 
    const breadcrumbs = document.querySelectorAll('.breadcrumbs');

    if (breadcrumbs.length > 1)
    {
        breadcrumbs[0].style.display = 'none';
    }

    // Create some padding if a breadcrumb is not there, but hide it if the design uses the 'hero' banner
    const noBreadcrumb = document.getElementById('breadcrumb-spacer');
    const usingHero = document.getElementById('hero');

    if (noBreadcrumb != null && usingHero != null)
    {
        noBreadcrumb.style.display = 'none';
    }

    // Share button hide when not focused
    const shareBtn = document.querySelector('.share-link');
    const sharePopup = document.querySelector('.a2a_kit');

    if (shareBtn && sharePopup)
    {
        shareBtn.addEventListener('blur', () =>
        {
            setTimeout(() =>
            {
                if (!sharePopup.contains(document.activeElement))
                {
                    UIkit.toggle(shareBtn).toggle(false);
                }
            }, 10);
        });
    }


    // Nav dropdown
    var dd = $('.nav-dropdown');
    $(document).on('beforeshow', dd, function (e)
    {
        if (e.target.id.indexOf('datalayer-id-') === 0)
        {
            $('#knockback').stop(true, true).fadeIn(0);
        }
    })
    $(document).on('hide', dd, function ()
    {
        $('#knockback').stop(true,true).fadeOut(300);
    })

    // Search box
    const searchLink = $('.search-wrapper a[href^="/search-results"]');
    const knockback = $('#knockback');
    const searchPanel = $('.search-wrapper .search-box-panel');
    const closeSearch = $('.btn-search-close');
    searchLink.click(function (e)
    {
        e.preventDefault();
        if (searchPanel.is(':visible'))
        {
            hideSearchPanel();
        }
        else
        {
            searchLink.hide();
            searchPanel.fadeIn(100);
            knockback.show();
            searchPanel.find('input').focus();
        }
    });
    closeSearch.click(function () {
        hideSearchPanel();
    });
    knockback.click(function () {
        hideSearchPanel();
    });
    $('header a').click(function () {
        if ($(this).is(searchLink)) return;
        //hideSearchPanel();
    });
    hideSearchPanel = function () {
        searchPanel.fadeOut(100);
        knockback.hide();
        searchLink.show();
    }

    // Overlay banner
    let ob = $('.overlay-banner');
    if (ob.length > 0) {
        const bannerClosed = sessionStorage.getItem('bannerClosed');
        if (!bannerClosed) {
            ob.show();
            $('body').addClass('hide-landbot');
        }
        const btnClose = $('.overlay-banner .overlay-close');
        btnClose.click(function () {
            sessionStorage.setItem('bannerClosed', 'true');
            $('body').removeClass('hide-landbot');
            ob.fadeOut();
        });
    }


    // Expand all top-level accordions only
    $('.accordion-expand').click(function () {

        // Only target accordions that are NOT inside another accordion
        $('.accordion-block ul[uk-accordion]').filter(function () {
            return $(this).closest('.uk-accordion-content').length === 0;
        }).each(function () {
            let $a = $(this);
            let $lis = $('> li', $a);
            let acc = UIkit.accordion($a);

            $lis.each(function (i) {
                if (!$(this).hasClass('uk-open')) {
                    acc.toggle(i, i===0);
                }
            });
        });

        $(this).hide();
        $('.accordion-close').show();
        $('.accordion-expand').hide();
    });

    // Close all top-level accordions only
    $('.accordion-close').click(function () {

        $('.accordion-block ul[uk-accordion]').filter(function () {
            return $(this).closest('.uk-accordion-content').length === 0;
        }).each(function () {
            let $a = $(this);
            let $lis = $('> li', $a);
            let acc = UIkit.accordion($a);

            $lis.each(function (i) {
                if ($(this).hasClass('uk-open')) {
                    acc.toggle(i, i===0);
                }
            });
        });

        $(this).hide();
        $('.accordion-expand').show();
        $('.accordion-close').hide();
    });





    // Accordion item click
    $('.accordion-block > ul > li').click(function () {
        setTimeout(function () {
            //expand
            if ($('.accordion-block > ul > li:not(.uk-open)').length > 0) {
                $('.accordion-expand').show();
                $('.mob .accordion-close').hide();
            }
            else {
                $('.accordion-expand').hide();
                $('.mob .accordion-close').show();
            }
            //close
            if ($('.accordion-block > ul > li.uk-open').length > 0) {
                $('.accordion-close').show();
                $('.mob .accordion-expand').hide();
            }
            else {
                $('.accordion-close').hide();
                $('.mob .accordion-expand').show();
            }
        }, 1);
    });


    $('#login-modal').on('hidden', function () {
        $('.temporary-message').hide();
    });
    // DAT Filters expander
    // Close
    $('.filter-expander').click(function () {
        let $a = $(this).parent().find('.accordion-block > ul');
        let $lis = $('> li', $a);

        if ($(this).hasClass('closed')) {
            for (let i = 0; i < $lis.length; i++) {
                // only open if it's not already open
                if (!$lis.eq(i).hasClass('uk-open')) {
                    UIkit.accordion($a).toggle(i, i === 0);
                }
            }
            // flip the button
            $(this).removeClass('closed');
        }
        else {
            for (let i = 0; i < $lis.length; i++) {
                // only close if it's not already closed
                if ($lis.eq(i).hasClass('uk-open')) {
                    UIkit.accordion($a).toggle(i, i === 0);
                }
            }
            // flip the button
            $(this).addClass('closed');
        }
    });



    // Print links
    $('.print-link').click(function () {

        let cp_formEmbed = $('.form-embed-component.cp_formEmbed');
        if (cp_formEmbed != null && cp_formEmbed.length > 0) {
            $('body').addClass('cp_formEmbed');
        }
        else
            $('body').removeClass('cp_formEmbed');
        window.print();
    });

    // Prevent multiple submissions of M-hance-related form posts.
    $('form').on('submit', function () {
        if ($(this).valid()) {
            $('.prevent-multi-submit').prop('disabled', true);
        }
        else {
            // reveal any accordion items with invalid fields
            $('ul.uk-accordion li').each(function (i) {
                if ($('span.field-validation-error', $(this)).length > 0) {
                    $(this).addClass('uk-open');
                    $('a.uk-accordion-title', $(this)).attr('aria-expanded', 'true');
                    $('.uk-accordion-content', $(this)).removeAttr('hidden');
                }
            });
            // show postcode error message
            if ($('#findAddressFld').is(':visible')) {
                $('#findAddressFld').next('span').removeAttr('hidden');
            }
        }
    });

    var tfContainer = $('#typeformHold');
    if (tfContainer.length > 0) {
        var height = tfContainer.data('height');
        tfContainer.find(">:first-child").css('height', height + 'px');
    }

});

//re-enable submit buttons
var enableSubmitButtons = () => $('.prevent-multi-submit').prop('disabled', false);